import { render, staticRenderFns } from "./UsergroupForm.vue?vue&type=template&id=e539bb66"
import script from "./UsergroupForm.vue?vue&type=script&lang=js"
export * from "./UsergroupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports